export const STYLE_MAP = {
  primary: {
    default: {
      backgroundColor: '#00A4F2'
    },
    base: {
      backgroundColor: '#E9F1FF'
    },
    plain: {
      backgroundColor: '#FFFFFF',
      borderWidth: '2px',
      borderColor: '#00A4F2'
    },
    text: {
      backgroundColor: '#FFFFFF',
      borderWidth: 0
    }
  },
  purple: {
    default: {
      backgroundColor: '#995EFC'
    },
    base: {
      backgroundColor: '#EEE6FF'
    },
    plain: {
      backgroundColor: '#FFFFFF',
      borderWidth: '2px',
      borderColor: '#995EFC'
    },
    text: {
      backgroundColor: '#FFFFFF',
      borderWidth: 0
    }
  },
  slate: {
    default: {
      backgroundColor: '#6575FF'
    },
    base: {
      backgroundColor: '#E6E8FF'
    },
    plain: {
      backgroundColor: '#FFFFFF',
      borderWidth: '2px',
      borderColor: '#6575FF'
    },
    text: {
      backgroundColor: '#FFFFFF',
      borderWidth: 0
    }
  },
  aqua: {
    default: {
      backgroundColor: '#29C3FF'
    },
    base: {
      backgroundColor: '#E6F8FF'
    },
    plain: {
      backgroundColor: '#FFFFFF',
      borderWidth: '2px',
      borderColor: '#29C3FF'
    },
    text: {
      backgroundColor: '#FFFFFF',
      borderWidth: 0
    }
  },
  turquoise: {
    default: {
      backgroundColor: '#00BDB2'
    },
    base: {
      backgroundColor: '#E6FFFD'
    },
    plain: {
      backgroundColor: '#FFFFFF',
      borderWidth: '2px',
      borderColor: '#00BDB2'
    },
    text: {
      backgroundColor: '#FFFFFF',
      borderWidth: 0
    }
  },
  yellow: {
    default: {
      backgroundColor: '#FFAA10'
    },
    base: {
      backgroundColor: '#FFF4E0'
    },
    plain: {
      backgroundColor: '#FFFFFF',
      borderWidth: '2px',
      borderColor: '#FFAA10'
    },
    text: {
      backgroundColor: '#FFFFFF',
      borderWidth: 0
    }
  },
  orange: {
    default: {
      backgroundColor: '#FFAA10'
    },
    base: {
      backgroundColor: '#FFF0E6'
    },
    plain: {
      backgroundColor: '#FFFFFF',
      borderWidth: '2px',
      borderColor: '#FFAA10'
    },
    text: {
      backgroundColor: '#FFFFFF',
      borderWidth: 0
    }
  },
  tomato: {
    default: {
      backgroundColor: '#F56428'
    },
    base: {
      backgroundColor: '#FFEaE6'
    },
    plain: {
      backgroundColor: '#FFFFFF',
      borderWidth: '2px',
      borderColor: '#F56428'
    },
    text: {
      backgroundColor: '#FFFFFF',
      borderWidth: 0
    }
  },
  gray: {
    default: {
      backgroundColor: '#7C879B'
    },
    base: {
      backgroundColor: '#CFD7E6'
    },
    plain: {
      backgroundColor: '#FFFFFF',
      borderWidth: '2px',
      borderColor: '#7C879B'
    },
    text: {
      backgroundColor: '#FFFFFF',
      borderWidth: 0
    }
  },
  red: {
    default: {
      backgroundColor: '#E61E1E'
    },
    base: {
      backgroundColor: '#fffeb7'
    },
    plain: {
      backgroundColor: '#FFFFFF',
      borderWidth: '2px',
      borderColor: '#E61E1E'
    },
    text: {
      backgroundColor: '#FFFFFF',
      borderWidth: 0
    }
  },
  brown: {
    default: {
      backgroundColor: '#86696B'
    },
    base: {
      backgroundColor: '#ffd9cf'
    },
    plain: {
      backgroundColor: '#FFFFFF',
      borderWidth: '2px',
      borderColor: '#86696B'
    },
    text: {
      backgroundColor: '#FFFFFF',
      borderWidth: 0
    }
  },
  colmo: {
    default: {
      backgroundColor: '#B35336'
    },
    base: {
      backgroundColor: '#313237'
    },
    plain: {
      backgroundColor: 'transparent',
      borderWidth: '2px',
      borderColor: '#B35336'
    },
    text: {
      backgroundColor: '#313237',
      borderWidth: 0
    }
  }
}

export const STYLE_MAP_DIABLO = {
  primary: {
    default: {
      backgroundColor: '#0490d3'
    },
    base: {
      backgroundColor: '#c7d4dc'
    },
    plain: {
      backgroundColor: '#101315',
      borderWidth: '2px',
      borderColor: '#0490d3'
    },
    text: {
      backgroundColor: '#101315',
      borderWidth: 0
    }
  },
  purple: {
    default: {
      backgroundColor: '#805ed1'
    },
    base: {
      backgroundColor: '#d2ceda'
    },
    plain: {
      backgroundColor: '#101315',
      borderWidth: '2px',
      borderColor: '#805ed1'
    },
    text: {
      backgroundColor: '#101315',
      borderWidth: 0
    }
  },
  slate: {
    default: {
      backgroundColor: '#5865DC'
    },
    base: {
      backgroundColor: '#E6E8FF'
    },
    plain: {
      backgroundColor: '#101315',
      borderWidth: '2px',
      borderColor: '#5865DC'
    },
    text: {
      backgroundColor: '#101315',
      borderWidth: 0
    }
  },
  aqua: {
    default: {
      backgroundColor: '#25A8DC'
    },
    base: {
      backgroundColor: '#E6F8FF'
    },
    plain: {
      backgroundColor: '#101315',
      borderWidth: '2px',
      borderColor: '#25A8DC'
    },
    text: {
      backgroundColor: '#101315',
      borderWidth: 0
    }
  },
  turquoise: {
    default: {
      backgroundColor: '#039D95'
    },
    base: {
      backgroundColor: '#c5dcda'
    },
    plain: {
      backgroundColor: '#101315',
      borderWidth: '2px',
      borderColor: '#039D95'
    },
    text: {
      backgroundColor: '#101315',
      borderWidth: 0
    }
  },
  yellow: {
    default: {
      backgroundColor: '#BE8214'
    },
    base: {
      backgroundColor: '#dcd1c1'
    },
    plain: {
      backgroundColor: '#101315',
      borderWidth: '2px',
      borderColor: '#BE8214'
    },
    text: {
      backgroundColor: '#101315',
      borderWidth: 0
    }
  },
  orange: {
    default: {
      backgroundColor: '#Db7122'
    },
    base: {
      backgroundColor: '#dcd1c1'
    },
    plain: {
      backgroundColor: '#101315',
      borderWidth: '2px',
      borderColor: '#Db7122'
    },
    text: {
      backgroundColor: '#101315',
      borderWidth: 0
    }
  },
  tomato: {
    default: {
      backgroundColor: '#d35926'
    },
    base: {
      backgroundColor: '#dbc9c6'
    },
    plain: {
      backgroundColor: '#101315',
      borderWidth: '2px',
      borderColor: '#d35926'
    },
    text: {
      backgroundColor: '#101315',
      borderWidth: 0
    }
  },
  gray: {
    default: {
      backgroundColor: '#6b7587'
    },
    base: {
      backgroundColor: '#b2b9b6'
    },
    plain: {
      backgroundColor: '#101315',
      borderWidth: '2px',
      borderColor: '#6b7587'
    },
    text: {
      backgroundColor: '#101315',
      borderWidth: 0
    }
  },
  red: {
    default: {
      backgroundColor: '#c61a1c'
    },
    base: {
      backgroundColor: '#dbc7c8'
    },
    plain: {
      backgroundColor: '#101315',
      borderWidth: '2px',
      borderColor: '#c61a1c'
    },
    text: {
      backgroundColor: '#101315',
      borderWidth: 0
    }
  },
  brown: {
    default: {
      backgroundColor: '#745b5e'
    },
    base: {
      backgroundColor: '#d0cecf'
    },
    plain: {
      backgroundColor: '#101315',
      borderWidth: '2px',
      borderColor: '#745b5e'
    },
    text: {
      backgroundColor: '#101315',
      borderWidth: 0
    }
  },
  colmo: {
    default: {
      backgroundColor: '#B35336'
    },
    base: {
      backgroundColor: '#313237'
    },
    plain: {
      backgroundColor: 'transparent',
      borderWidth: '2px',
      borderColor: '#B35336'
    },
    text: {
      backgroundColor: '#1c1e21',
      borderWidth: 0
    }
  }
}

export const TEXT_STYLE_MAP = {
  primary: {
    default: {
      color: '#FFFFFF'
    },
    base: {
      color: '#00A4F2'
    },
    plain: {
      color: '#00A4F2'
    },
    text: {
      color: '#00A4F2'
    }
  },
  purple: {
    default: {
      color: '#FFFFFF'
    },
    base: {
      color: '#995EFC'
    },
    plain: {
      color: '#995EFC'
    },
    text: {
      color: '#995EFC'
    }
  },
  slate: {
    default: {
      color: '#FFFFFF'
    },
    base: {
      color: '#6575FF'
    },
    plain: {
      color: '#6575FF'
    },
    text: {
      color: '#6575FF'
    }
  },
  aqua: {
    default: {
      color: '#FFFFFF'
    },
    base: {
      color: '#29C3FF'
    },
    plain: {
      color: '#29C3FF'
    },
    text: {
      color: '#29C3FF'
    }
  },
  turquoise: {
    default: {
      color: '#FFFFFF'
    },
    base: {
      color: '#00BDB2'
    },
    plain: {
      color: '#00BDB2'
    },
    text: {
      color: '#00BDB2'
    }
  },
  yellow: {
    default: {
      color: '#FFFFFF'
    },
    base: {
      color: '#FFAA10'
    },
    plain: {
      color: '#FFAA10'
    },
    text: {
      color: '#FFAA10'
    }
  },
  orange: {
    default: {
      color: '#FFFFFF'
    },
    base: {
      color: '#FFAA10'
    },
    plain: {
      color: '#FFAA10'
    },
    text: {
      color: '#FFAA10'
    }
  },
  tomato: {
    default: {
      color: '#FFFFFF'
    },
    base: {
      color: '#F56428'
    },
    plain: {
      color: '#F56428'
    },
    text: {
      color: '#F56428'
    }
  },
  gray: {
    default: {
      color: '#FFFFFF'
    },
    base: {
      color: '#7C879B'
    },
    plain: {
      color: '#7C879B'
    },
    text: {
      color: '#7C879B'
    }
  },
  red: {
    default: {
      color: '#FFFFFF'
    },
    base: {
      color: '#E61E1E'
    },
    plain: {
      color: '#E61E1E'
    },
    text: {
      color: '#E61E1E'
    }
  },
  brown: {
    default: {
      color: '#FFFFFF'
    },
    base: {
      color: '#86696B'
    },
    plain: {
      color: '#86696B'
    },
    text: {
      color: '#86696B'
    }
  },
  colmo: {
    default: {
      color: 'rgb(204, 204, 204)'
    },
    base: {
      color: 'rgb(204, 204, 204)'
    },
    plain: {
      color: '#B35336'
    },
    text: {
      color: '#B35336'
    }
  }
}

export const TEXT_STYLE_MAP_DIABLO = {
  primary: {
    default: {
      color: '#dcdddd'
    },
    base: {
      color: '#0490d3'
    },
    plain: {
      color: '#0490d3'
    },
    text: {
      color: '#0490d3'
    }
  },
  purple: {
    default: {
      color: '#dcdddd'
    },
    base: {
      color: '#805ed1'
    },
    plain: {
      color: '#805ed1'
    },
    text: {
      color: '#805ed1'
    }
  },
  slate: {
    default: {
      color: '#dcdddd'
    },
    base: {
      color: '#5865DC'
    },
    plain: {
      color: '#5865DC'
    },
    text: {
      color: '#5865DC'
    }
  },
  aqua: {
    default: {
      color: '#dcdddd'
    },
    base: {
      color: '#25A8DC'
    },
    plain: {
      color: '#25A8DC'
    },
    text: {
      color: '#25A8DC'
    }
  },
  turquoise: {
    default: {
      color: '#dcdddd'
    },
    base: {
      color: '#039D95'
    },
    plain: {
      color: '#039D95'
    },
    text: {
      color: '#039D95'
    }
  },
  yellow: {
    default: {
      color: '#dcdddd'
    },
    base: {
      color: '#BE8214'
    },
    plain: {
      color: '#BE8214'
    },
    text: {
      color: '#BE8214'
    }
  },
  orange: {
    default: {
      color: '#dcdddd'
    },
    base: {
      color: '#Db7122'
    },
    plain: {
      color: '#Db7122'
    },
    text: {
      color: '#Db7122'
    }
  },
  tomato: {
    default: {
      color: '#dcdddd'
    },
    base: {
      color: '#d35926'
    },
    plain: {
      color: '#d35926'
    },
    text: {
      color: '#d35926'
    }
  },
  gray: {
    default: {
      color: '#dcdddd'
    },
    base: {
      color: '#6b7587'
    },
    plain: {
      color: '#6b7587'
    },
    text: {
      color: '#6b7587'
    }
  },
  red: {
    default: {
      color: '#dcdddd'
    },
    base: {
      color: '#c61a1c'
    },
    plain: {
      color: '#c61a1c'
    },
    text: {
      color: '#c61a1c'
    }
  },
  brown: {
    default: {
      color: '#dcdddd'
    },
    base: {
      color: '#745b5e'
    },
    plain: {
      color: '#745b5e'
    },
    text: {
      color: '#745b5e'
    }
  },
  colmo: {
    default: {
      color: 'rgb(204, 204, 204)'
    },
    base: {
      color: 'rgb(204, 204, 204)'
    },
    plain: {
      color: '#B35336'
    },
    text: {
      color: '#B35336'
    }
  }
}

export const BUTTON_STYLE_MAP = {
  flexiable: {
    width: '750px',
    height: '128px',
    borderRadius: 0
  },
  full: {
    width: '686px',
    height: '92px',
    borderRadius: '46px',
    paddingLeft: '46px',
    paddingRight: '46px'
  },
  big: {
    width: '550px',
    height: '92px',
    borderRadius: '46px',
    paddingLeft: '46px',
    paddingRight: '46px'
  },
  medium: {
    width: '280px',
    height: '72px',
    borderRadius: '36px',
    paddingLeft: '36px',
    paddingRight: '36px'
  },
  small: {
    width: '164px',
    height: '60px',
    borderRadius: '30px',
    paddingLeft: '15px',
    paddingRight: '15px'
  }
}

export const COLMO_BUTTON_STYLE_MAP = {
  flexiable: {
    width: '750px',
    height: '128px',
    borderRadius: 0
  },
  full: {
    width: '688px',
    height: '96px',
    borderRadius: '16px',
    paddingLeft: '46px',
    paddingRight: '46px'
  },
  big: {
    width: '688px',
    height: '96px',
    borderRadius: '16px',
    paddingLeft: '46px',
    paddingRight: '46px'
  },
  medium: {
    width: '688px',
    height: '80px',
    borderRadius: '16px',
    paddingLeft: '28px',
    paddingRight: '28px'
  },
  small: {
    width: '128px',
    height: '56px',
    borderRadius: '28px',
    paddingLeft: '0px',
    paddingRight: '0px'
  }
}

export const TEXT_FONTSIZE_STYLE_MAP = {
  flexiable: {
    fontSize: '32px'
  },
  full: {
    fontSize: '32px'
  },
  big: {
    fontSize: '32px'
  },
  medium: {
    fontSize: '28px'
  },
  small: {
    fontSize: '26px'
  }
}

export const COLMO_TEXT_FONTSIZE_STYLE_MAP = {
  flexiable: {
    fontSize: '32px'
  },
  full: {
    fontSize: '32px'
  },
  big: {
    fontSize: '32px'
  },
  medium: {
    fontSize: '32px'
  },
  small: {
    fontSize: '24px'
  }
}



// WEBPACK FOOTER //
// ./packages/dof-button/type.js